<form id="user-form" [formGroup]="addEditForm" *ngIf="fields && addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate(dialogBoxUser)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <span formGroupName="user">
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.login.nullable}">{{ fields.login.keyName }}</label></div>
        <div class="ui-grid-col-8">
          <input type="text" [maxlength]="fields.login.width" formControlName="login" pInputText/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm['controls'].user" [validation]="fields.login"></app-validation-msg>
        </div>
      </div>
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.role_id.nullable}">{{ fields.role_id.keyName }}</label></div>
        <div class="ui-grid-col-8">
          <p-dropdown formControlName="role_id" [style]="{'width':'100%'}"
                      [options]="srvRoles.rolesForDropdown" [disabled]="userToClone && userToClone.roleId"></p-dropdown>
                      <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm['controls'].user" [validation]="fields.role_id"></app-validation-msg>
        </div>
      </div>
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.name.nullable}">{{ fields.name.keyName }}</label></div>
        <div class="ui-grid-col-8">
          <input type="text" [maxlength]="fields.name.width" formControlName="name" pInputText/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm['controls'].user" [validation]="fields.name"></app-validation-msg>
        </div>
      </div>
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.surname.nullable}">{{ fields.surname.keyName }}</label></div>
        <div class="ui-grid-col-8">
          <input type="text" [maxlength]="fields.surname.width" formControlName="surname" pInputText/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm['controls'].user" [validation]="fields.surname"></app-validation-msg>
        </div>
      </div>
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.email.nullable}">{{ fields.email.keyName }}</label></div>
        <div class="ui-grid-col-8">
          <input type="email" [pattern]="fields.email.pattern" [maxlength]="fields.email.width" pInputText formControlName="email"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm['controls'].user" [arrayValidators]="[validators.emailOrEmpty]" [validation]="fields.email"></app-validation-msg>
        </div>
      </div>
      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-6">
          <p-checkbox
            [(ngModel)]="externalUser"
            [binary]="true"
            formControlName="flg_ext"
            [disabled]="sendEmail"
          >
          </p-checkbox>
          <label>
            {{ fields.flg_ext.keyName }}
          </label>
        </div>
        <div class="ui-grid-col-6" *ngIf="isNew">
          <p-checkbox
            [(ngModel)]="sendEmail"
            [binary]="true"
            formControlName="send_email"
            [disabled]="externalUser">
          </p-checkbox>
          <label>
            {{ fields.send_email.keyName }}
          </label>
        </div>
      </div>
    </span>

    <span *ngIf="isNew">
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.date_start.nullable}">{{ fields.date_start.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <app-kv-calendar
          #dateStartField
          [defaultDate]="maxDate"
          [inputName]="'date_start'"
          [yearRange]="'1900:2099'"
          [formData]="addEditForm"
          [startDateSelector]="true"
          [endDateInputName]="'date_end'"
          [endDateCalendar]="dateEndField">
        ></app-kv-calendar>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.date_start"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.date_end.nullable}">{{ fields.date_end.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <app-kv-calendar
            #dateEndField
            [defaultDate]="maxDate"
            [inputName]="'date_end'"
            [yearRange]="'1900:2099'"
            [formData]="addEditForm"
            [endDateSelector]="true"
            [startDateInputName]="'date_start'"
            [startDateCalendar]="dateStartField">
        </app-kv-calendar>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.date_end"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.companies.nullable}">
          {{ fields.companies.keyName }}
        </label></div>
      <div class="ui-grid-col-8">
        <p-listbox [style]="{'width':'100%','max-height':'300px', 'overflow-y': 'auto'}"
          formControlName="companies"
          [options]="companies"
          multiple="multiple"
          checkbox="checkbox"
          filter="filter"
          [disabled]="userToClone && userToClone.companies && userToClone.companies.length > 0"></p-listbox>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.companies"></app-validation-msg>
      </div>
    </div>
    </span>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{dialogBoxUser.user.id ? ('common.edit' | translate) :  ('common.add' | translate) }}"></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/users/userForm.component.html